import { useSelector } from "react-redux";

import { ComponentPurchases } from "@components";
import { selectAuth } from "@redux";


export const PagePurchases = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentPurchases
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
